import AudiencePage from "../components/marketing/AudiencePage";
import { SHOTS } from "../components/marketing/features";

const STEPS = [
  { title: "The coach invites you", tier: "free", shot: SHOTS.staff,
    body: "From the Roster, the coach taps Invite a Team Mom or Staff and picks a role: Team Mom, Team Dad, coordinator or assistant coach. You accept from the email link." },
  { title: "Run volunteers and snacks", tier: "board", shot: SHOTS.volunteers,
    body: "With volunteer access you can rotate snack duty across families in one tap or post duties parents claim. Volunteer tools need The Chalkboard on the team." },
  { title: "Post team updates", tier: "free", shot: SHOTS.talkCoach,
    body: "With Chalk Talk access you can post announcements to families and see how many have read them." },
];

export default function TeamStaff() {
  return (
    <AudiencePage
      id="team-staff" docTitle="Chalk OS for team staff: Team Moms, Dads and coordinators"
      eyebrow="For Team Moms, Dads & coordinators" title="Help run the team." marker="With the right keys."
      intro="Coaches invite staff and decide exactly what they can do. You get the tools for your job and nothing you weren't given."
      steps={STEPS} featureTitle="How staff access works." featureSub="The coach stays in control."
      features={["staff", "staffPerms", "staffAccept", "staffParent", "staffMedical", "volunteers", "chalkTalk"]}
    />
  );
}
